import { createFileRoute } from "@tanstack/react-router";
import { ByggeledelsePage, byggeledelseHead } from "@/pages/ByggeledelsePage";

export const Route = createFileRoute("/de/baumanagement")({
  head: () => byggeledelseHead("de"),
  component: () => <ByggeledelsePage locale="de" />,
});
